// Italian

const lang = {
  gateMediaPreviewHeader: 'Forse potrebbe interessarti',
  loadmore: 'Altro',
  nextMedia: 'Media successivo',
  previousMedia: 'Media precedente',
  closePost: 'Chiudi post',
  nextPost: 'Post successivo',
  previousPost: 'Post precedente',
  outOfStock: 'Esaurito',
  numberOfReviews(n) {
    return n === 1 ? 'recensione' : 'recensioni'
  },
  reportFormField: 'Inserisci un messaggio',
  reportPost: 'Segnala post',
  reportFormTitle: 'Vuoi segnalare questa immagine?',
  reportFormDetails: `Se ritieni che l'immagine sia inappropriata, illegale o violi i diritti di qualcuno, puoi segnalare il contenuto. Se segnali l'immagine/il testo, i moderatori del contenuto saranno avvisati e verranno prese le misure appropriate.`,
  reportFormMessagePlaceholder: 'Specifica il motivo della segnalazione',
  reportFormMessageLabel: 'Messaggio',
  reportFormEmailLabel: 'La tua email',
  reportFormSubmitButtonText: 'Invia segnalazione',
  reportFormCancelButtonText: 'Annulla',
  reportFormSentTitle: 'Grazie per la segnalazione!',
  reportFormSentCloseButtonText: 'Chiudi modale',
  cardAndTileAriaLabel: 'Di seguito un elenco di post da account di vari social media',
  carouselAriaLabel: 'Di seguito un carousel con post da account di vari social media',
  singleAriaLabel: 'Di seguito è riportato un post da un account di social media',
  poweredBy: 'Alimentato da Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publicata il ${date}` : ''
    const createdByString = userName ? ` di ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Carica i tuoi contenuti multimediali',
  openTheGate: 'Apri la finestra di dialogo',
}

export default lang
